export const LEGACY_DEFAULT_WORKSPACE_ID = 'defaultworkspace';
export const MAIN_WORKSPACE_PREFIX = 'main_';
export const PRIVATE_WORKSPACE_PREFIX = 'private_';
// Back-compat alias so existing imports of DEFAULT_WORKSPACE_ID keep working.
export const DEFAULT_WORKSPACE_ID = LEGACY_DEFAULT_WORKSPACE_ID;

export const normalizeWorkspaceContextId = (workspaceId) => {
    if (workspaceId === null || workspaceId === undefined) {
        return null;
    }
    const normalizedWorkspaceId = String(workspaceId).trim();
    return normalizedWorkspaceId || null;
};

// Only main_ workspaces are the protected always-available main workspace class.
export const isDefaultWorkspaceContextId = (workspaceId) => {
    const id = normalizeWorkspaceContextId(workspaceId);
    return Boolean(id && id.startsWith(MAIN_WORKSPACE_PREFIX));
};

export const isPrivateWorkspaceContextId = (workspaceId) => {
    const id = normalizeWorkspaceContextId(workspaceId);
    return Boolean(id && id.startsWith(PRIVATE_WORKSPACE_PREFIX));
};

export const areWorkspaceContextIdsEqual = (leftWorkspaceId, rightWorkspaceId) => {
    return normalizeWorkspaceContextId(leftWorkspaceId) === normalizeWorkspaceContextId(rightWorkspaceId);
};